
<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      mini-variant-width="72"
      width="260"
      color="#0C2F53"
      dark
      app
      class="side-nav"
    >
      <div class="brand" :class="{ 'brand--mini': mini }">
        <img v-if="!mini" src="@/assets/Logo-depa.png" alt="depa" class="brand-logo" />
        <v-btn icon small class="collapse-btn" @click.stop="mini = !mini">
          <v-icon>{{ mini ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
        </v-btn>
      </div>

      <div class="user-card" :class="{ 'user-card--mini': mini }">
        <v-avatar color="secondary" size="40" class="user-avatar">
          <span class="user-initials">{{ initials }}</span>
        </v-avatar>
        <div v-if="!mini" class="user-info">
          <div class="user-name">{{ getUser.name }} {{ getUser.surname }}</div>
          <div class="user-role">{{ getUser.admin === 1 ? 'ผู้ดูแลระบบ' : 'ผู้ใช้งาน' }}</div>
        </div>
      </div>

      <v-list nav class="nav-list">
        <v-list-item
          v-for="menu in filteredMenus"
          :key="menu.path"
          :to="menu.path"
          :class="{ 'nav-item--active': isActive(menu) }"
          class="nav-item"
          active-class=""
          exact
        >
          <v-list-item-icon>
            <v-icon>{{ menu.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ menu.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-list nav class="nav-list">
          <v-list-item to="/logout" class="nav-item nav-item--logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>ออกจากระบบ</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-app-bar app flat color="white" class="top-bar">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <span class="top-bar-title">ระบบลงทะเบียนเข้าร่วมประชุม</span>
    </v-app-bar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'NavigationView',
  data() {
    return {
      menus: [
        { title: 'ปฏิทินการประชุม', icon: 'mdi-calendar-month', path: '/dashboard', match: ['/dashboard'], adminOnly: false },
        { title: 'การประชุม', icon: 'mdi-calendar-account', path: '/listmeeting', match: ['/listmeeting', '/createmeeting'], adminOnly: false },
        { title: 'จัดการผู้ใช้งาน', icon: 'mdi-account-cog', path: '/listuser', match: ['/listuser', '/createuser'], adminOnly: true },
        { title: 'การตั้งค่า', icon: 'mdi-cog-outline', path: '/settings', match: ['/settings'], adminOnly: true },
      ],
      mini: false,
      drawer: window.innerWidth > 960,
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    filteredMenus() {
      return this.menus.filter(menu => {
        return !menu.adminOnly || this.getUser.admin === 1;
      });
    },
    initials() {
      const first = (this.getUser.name || '').trim().charAt(0);
      const last = (this.getUser.surname || '').trim().charAt(0);
      return (first + last).toUpperCase() || '?';
    },
  },
  methods: {
    isActive(menu) {
      const path = this.$route.path.toLowerCase();
      return menu.match.some(p => path === p);
    },
  },
}
</script>
<style scoped>
.side-nav {
  border-right: none !important;
}

.brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 12px 20px;
}

.brand--mini {
  justify-content: center;
  padding: 20px 0 12px;
}

.brand-logo {
  width: 120px;
  height: auto;
}

.collapse-btn {
  color: rgba(255, 255, 255, 0.7) !important;
}

.user-card {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 12px 16px;
  padding: 12px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.08);
}

.user-card--mini {
  justify-content: center;
  margin: 8px 8px 16px;
  padding: 8px 0;
  background-color: transparent;
}

.user-initials {
  color: #0C2F53;
  font-weight: 700;
  font-size: 15px;
}

.user-info {
  min-width: 0;
}

.user-name {
  color: #FFFFFF;
  font-weight: 600;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  color: #FFC600;
  font-size: 13px;
}

.nav-list {
  padding: 0 12px;
}

.nav-item {
  border-radius: 10px !important;
  margin-bottom: 4px;
  color: rgba(255, 255, 255, 0.85) !important;
  border-left: 4px solid transparent;
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.nav-item--active {
  background-color: rgba(255, 198, 0, 0.14) !important;
  border-left-color: #FFC600;
}

.nav-item--active .v-icon,
.nav-item--active .v-list-item__title {
  color: #FFC600 !important;
  font-weight: 600;
}

.nav-item--logout {
  margin-bottom: 16px;
}

.top-bar {
  border-bottom: 1px solid #E8EDF3 !important;
}

.top-bar-title {
  color: #0C2F53;
  font-weight: 600;
  font-size: 17px;
  margin-left: 4px;
}
</style>
